(ns assemble.component.upload
  (:require ["@mui/material/Button$default" :as Button]
            ["@mui/material/Icon$default" :as Icon]
            [common.util :refer [spread-props]]
            [uix.core :refer [$ defui]]))

(defui upload-button [props]
  ($ Button
     (spread-props {:variant :contained
                    :data-testid "uploadButton"
                    :startIcon ($ Icon "cloud_upload")}
                   props)
     "Upload"))
